import { useState } from "react";
import { Image } from "./image";
import Pagination from "./Paginate/Pagination";
import Foto from "../data/Gallery.json";
import Fade from 'react-reveal/Fade';
import Bounce from 'react-reveal/Bounce';
import Zoom from 'react-reveal/Zoom';
export const Gallery = () => {
	const galery = Foto;
	const [currentPage, setCurrentPage] = useState(1);
	const [postPerPage] = useState(3);

	const indexOfLastPost = currentPage * postPerPage;
	const indexOfFirstPost = indexOfLastPost - postPerPage;
	const currentPosts = galery.slice(indexOfFirstPost, indexOfLastPost);

	const paginate = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	return (
		<div id="portfolio" className="text-center">
			<div className="container">
				<div className="section-title">
					<Fade bottom duration={1500}>
					<h2>Gallery</h2>
					</Fade>
					<Bounce bottom duration={1500}> 
					<p>Berupa Semua Kegiatan yang Pernah Dilakukan.</p>
					</Bounce>
				</div>
			<Zoom bottom duration={1500}>
				<div className="row">
					<div className="container">
						<div className="card">
							<div className="card-body">
								{currentPosts.map((item, index) => {
									return (
										<div key={index}>
											<div
												key={`${item.title}-${index}`}
												className="col-sm-6 col-md-4 col-lg-4"
											>
												<Image
													title={item.title}
													largeImage={item.largeImage}
													smallImage={item.smallImage}
                         />
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="container">
						<div className="d-flex justfiy-content-center">
							<Pagination
								paginate={paginate}
								postsPerPage={postPerPage}
								totalPosts={galery.length}
								currentPage={currentPage}
							/>
						</div>
					</div>
				</div>
				</Zoom>
			</div>
		</div>
	);
};
